module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD/SURBVHgBjVOLFYIwDGx9DsAIbGA3sCPABjiBjOIGZQNHgA3ECXQD2KAmcvhCpZR7715oc7n0h1Y74b03FJhnRGZPLHWkIKdgiSdRkEX8O40iFlwhtpGCEZ05FjJxRNeWmAdFPfj8dtO6F9qljhLOT3gRa6LFyv62CM2svePbcXLAwKoIVgx43GJcJU3WDDA/wyjh+BPsMDCYG6RwEMJsywC5GvOt7GiEUb1lAL1D7hbuvUHCbRlA+0C+iJn4hEHm5aESDiqOTk2vN4RBHPkBhh2sX8diRWuHqgOjSk1/6QzeM9/Wm1ji26npF7nQShqVQnBryfPaMpJPfMDtLQw+xTHUEtklQm8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-six/plane.png
// module id = BEeg
// module chunks = 0